import memoize from 'fast-memoize';
const CLOUDINARY_CLOUD_NAME = 'xperience-io';
const BASE_URI = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload`;
/** Provides access to Cloudinary functionality. */
class CloudinaryService {
    constructor() {
        this.url = memoize(createUrl, {
            strategy: memoize.strategies.variadic,
        });
    }
}
/** Create a Cloudinary URL. */
function createUrl(publicId, options = {}) {
    if (!publicId) {
        return createUrl('kentico_logo_kmlajq', options);
    }
    const transforms = combineTransforms({
        crop: 'lfill',
        dpr: 1,
        fetchFormat: 'auto',
        gravity: 'auto',
        quality: 'auto',
        ...options,
    });
    // Encode public id value to fix issue with spaces breaking srcset.
    const encodedId = encodeURIComponent(publicId);
    return combineUrlSegments(encodedId, transforms, options.fetchFormat);
}
export default new CloudinaryService();
/** Combine segments of URL together to form full Cloudinary URL. */
function combineUrlSegments(publicId, transforms, fetchFormat = '') {
    let url = BASE_URI;
    if (transforms && transforms.length) {
        url += `/${transforms}`;
    }
    url += `/${removeExtension(publicId.toLowerCase())}`;
    if (fetchFormat && fetchFormat !== 'auto') {
        url += `.${fetchFormat}`;
    }
    return url;
}
/** Create combined transform string. */
function combineTransforms({ aspectRatio, background, crop, defaultImageId, dpr, fetchFormat, gravity, height, quality, width, zoom, }) {
    let transforms = '';
    // Apply sizing and cropping transforms.
    const aspectRatioString = aspectRatio;
    const aspectRatioNumber = aspectRatio;
    if (aspectRatioString && aspectRatioString.length) {
        transforms += `,ar_${aspectRatioString}`;
    }
    else if (aspectRatioNumber && aspectRatioNumber > 0) {
        transforms += `,ar_${aspectRatioNumber}`;
    }
    if (background && background.length) {
        const sanitizeBg = background.indexOf('#') === 0 ? background.substring(1) : background;
        transforms += `,b_rgb:${sanitizeBg}`;
    }
    if (crop && crop.length) {
        transforms += `,c_${crop}`;
    }
    if (dpr && dpr > 0) {
        transforms += `,dpr_${dpr}`;
    }
    if (gravity && gravity.length) {
        transforms += `,g_${gravity}`;
    }
    if (height && height > 0) {
        transforms += `,h_${height}`;
    }
    if (width && width > 0) {
        transforms += `,w_${width}`;
    }
    if (zoom) {
        transforms += `,z_${zoom}`;
    }
    // Add separator for chained transform.
    transforms += '/';
    // Add default image.
    if (defaultImageId && defaultImageId.length) {
        transforms += `,d_${defaultImageId}`;
    }
    // Add separator for chained transform.
    transforms += '/';
    // Apply quality and format transforms.
    if (fetchFormat && fetchFormat === 'auto') {
        transforms += ',f_auto';
    }
    const qualityString = quality;
    const qualityNumber = quality;
    if (qualityString && qualityString.length) {
        transforms += `,q_${qualityString}`;
    }
    else if (qualityNumber && qualityNumber > 0) {
        transforms += `,q_${qualityNumber}`;
    }
    // Clean up separators.
    transforms = transforms.replace(/\/\//g, '/');
    transforms = transforms.replace(/\/,/g, '/');
    // Remove preceeding comma.
    transforms = transforms.indexOf(',') === 0 ? transforms.substr(1) : transforms;
    return transforms;
}
/** Remove extension from string. */
function removeExtension(str) {
    const index = str.lastIndexOf('.');
    if (index >= 0) {
        return str.substring(0, index);
    }
    return str;
}
